export default "__VITE_ASSET__SCICrXjS__"